/* eslint-disable */
import { xenv, xenvActionFactory } from '../xenv';
import { webappXenv } from '../xenv/webappXenv';
import { build, query, hashQuery, parseURL, buildSearch } from '../query';
import { utils } from '../utils';
import { getNineChapterShareParamsNew } from '../statistic';
import { storage } from '../storage';
import { getOmega } from '../omega';
import { 
// 没用到的注释掉
alimpSetShare, alimpDisableShare, alimpInvokeShareV2, 
// alipayInvokeShare,
// bdmpShare,
// cowxmpShare,
sfcwxmpSetShare, sfcwxmpInvokeShareV2, sfcalimpSetShare, sfcalimpInvokeShareV2, 
// driverSetShare,
// driverInvokeShare,
// driverShare,
// drwxmpShare,
// gjwxmpShare,
// gaswxmpSetShare,
// gaswxmpInvokeShare,
// h5Share,
kfalimpSetShare, kfalimpInvokeShareV2, kfwxmpSetShare, kfwxmpInvokeShareV2, 
// kfdriverSetShare,
// kfdriverInvokeShare,
// kfdwxmpShare,
kfpassengerSetShare, kfpassengerInvokeShare, 
// mqqShare,
passengerSetShare, passengerDisableShare, passengerInvokeShare, 
// qjwxmpSetShare,
// qjwxmpInvokeShare,
// qqmpShare,
// thwxmpShare,
// weixinSetShare,
weixinDisableShare, 
// weixinInvokeShare,
wxmpSetShare, wxmpDisableShare, wxmpInvokeShareV2, 
// dympSetShare,
// dympInvokeShare,
hitchappSetShare, 
// hitchappInvokeShare,
// hywxmpSetShare,
// hywxmpInvokeShare,
// hyalimpSetShare,
// hyalimpInvokeShare,
// cralimpSetShare,
// cralimpInvokeShare,
cralimpDisableShare, 
// eshwxmpSetShare,
// eshwxmpInvokeShare,
// hwfastappSetShare,
hwfastappInvokeShareV2, } from '../platform/xenv';
import { getShareDataFromInit, getTargetShareConf } from '@didi/webx-js-core';
/* eslint-disabeld  no-case-declarations */
const currentUrl = window.location.href;
const urlParams = Object.assign({}, query(currentUrl), hashQuery(currentUrl));
const urlIgnoreList = [
    'token',
    'cityid',
    'city_id',
    'cityId',
    'lat',
    'lng',
    'openid',
    'appid',
    'from',
    'lang',
];
const channelMapping = {
    wx_appmsg: {
        // 微信好友
        API: 'shareWeixinAppmsg'
    },
    wx_timeline: {
        // 微信朋友圈
        API: 'shareWeixinTimeline'
    },
    ali_appmsg: {
        // 支付宝好友
        API: 'shareAlipayFriend'
    },
    ali_timeline: {
        // 支付宝朋友圈
        API: 'shareAlipayLife'
    },
    qq_appmsg: {
        // QQ好友
        API: 'shareQqAppmsg'
    },
    qzone: {
        // QQ空间
        API: 'shareQzone'
    },
    dcommand: {
        // didi口令
        API: 'shareWeixinKouling'
    },
    dy_appmsg: {
        // 抖音好友
        API: 'shareDouyinAppmsg'
    },
};
const filtrateParams = (url) => {
    const decode = parseURL(url);
    if (decode.search) {
        const searchMap = query(url);
        urlIgnoreList.forEach(key => {
            if (searchMap[key])
                delete searchMap[key];
            if (searchMap.url) {
                searchMap.url = encodeURIComponent(decodeURIComponent(searchMap.url));
            }
        });
        decode.search = buildSearch(searchMap, false);
    }
    return decode.protocol + decode.hostAndPath + decode.search + decode.hash;
};
function getAttrsFromVnode(el, attr) {
    // 当前vnode为component，并且vnode.elm.__vue__ 即组件vnode渲染的dom和真是dom相同
    return el?.dataset?.[attr];
}
const getXposShareInfoByDom = function (el) {
    if (!el)
        return {};
    const en = getAttrsFromVnode(el, 'xName'); // data-x-name
    const data = getAttrsFromVnode(el, 'xState') || {}; // data-x-state
    const idx = getAttrsFromVnode(el, 'xIndex');
    const cid = getAttrsFromVnode(el, 'xCid');
    return {
        en, data, idx, cid
    };
};
function isDOMShare(item) {
    // 首先判断是否支持HTMLELement，如果支持，使用HTMLElement，如果不支持，通过判断DOM的特征，如果拥有这些特征说明就是ODM节点，特征使用的越多越准确
    return (typeof HTMLElement === 'function')
        ? (item instanceof HTMLElement)
        : (item && (typeof item === 'object') && (item.nodeType === 1) && (typeof item.nodeName === 'string'));
}
const disableShare = () => {
    const xenvSetShareMapping = {
        passenger: passengerDisableShare,
        weixin: weixinDisableShare,
        wxmp: wxmpDisableShare,
        alimp: alimpDisableShare,
        cralimp: cralimpDisableShare
    };
    const fn = xenvActionFactory('setShare', xenvSetShareMapping);
    return fn();
};
const getFormatShareConf = function (option) {
    const { shareConf = {}, query } = option;
    const { xposShare } = shareConf;
    let _shareConf = utils.cloneDeep(shareConf); // 深拷贝，避免影响原始数据
    const { share_channels } = _shareConf;
    Object.keys(share_channels).forEach(v => {
        const { share_type } = share_channels[v];
        if (share_type === 'image') {
            // 分享图片的话，不会从渠道里读path
            return _shareConf;
        }
        else {
            let { resLink, linkType } = getShareLink(share_channels[v]);
            resLink = build(resLink, {
                ...query,
                ...getNineChapterShareParamsNew({ xposShare }),
                appid: undefined
            });
            // const targetPath = `${path}&xpos_share=${JSON.stringify(xposShare || {})}&dsi=${query.dsi}`
            share_channels[v][linkType] = resLink;
        }
    });
    console.log('current shareChannels', share_channels);
    return _shareConf;
};
const getShareLink = function (shareChannel) {
    const { share_type } = shareChannel;
    const type = share_type.split('_')[1];
    const linkTypeMap = {
        'h5': 'link',
        'miniapp': 'path'
    };
    const shareLinkType = linkTypeMap[type];
    if (shareLinkType && shareChannel[shareLinkType]) {
        return {
            linkType: shareLinkType,
            resLink: shareChannel[shareLinkType]
        };
    }
    else {
        throw new Error(`当前分享类型${share_type}，没有下发对应的链接字段${shareLinkType}`);
    }
};
const convertSetShareMaterial = function (_shareConf) {
    // 物料转化规则，本次支持passenger -> miniApp； wxmp -> wxmp 的分享格式化。
    // 其余环境by需求扩充
    const currentXenv = xenv();
    let result = null;
    switch (currentXenv) {
        case 'hitchapp':
        case 'passenger': // 滴滴出行乘客端App
        case 'kfpassenger':
            /* 各业务线乘客端 format参考fusion */
            result = formatFusionShareConfig(_shareConf);
            break;
        case 'sfcwxmp':
        case 'wxmp':
        case 'kfwxmp':
            // case 'hwfastapp': // 华为快应用webapp
            // 小程序下的格式化
            /* 各业务线微信小程序webview环境 */
            result = formatWebviewSetShareConfig('wx', _shareConf); // 小程序分享中间页物料格式化
            break;
        case 'alimp':
        case 'sfcalimp':
        case 'kfalimp':
            // 小程序下的格式化
            /* 各业务线微信小程序webview环境 */
            result = formatWebviewSetShareConfig('ali', _shareConf); // 小程序分享中间页物料格式化
            break;
    }
    return result;
};
const formatFusionInvokeShareConfig = function (shareConf) {
    let { share_channels } = shareConf;
    if (Object.keys(share_channels).length > 1) {
        return formatFusionShareConfig(shareConf);
    }
    else {
        const [channel, channelConf] = Object.entries(share_channels)[0];
        const channelName = channelMapping[channel] && channelMapping[channel].API;
        const { share_type } = channelConf;
        const currentConfig = {
            ...shareConf[share_type]
        }; // 传给底层的分享物料
        const { title, img, icon, desc } = currentConfig;
        const { appid, path, miniprogram_type = 0, link } = channelConf;
        const shareMaterial = channelConf.share_type.split('_');
        switch (shareMaterial[1] || shareMaterial[0]) {
            // 兼容share_type = "image"
            // 具体处理过程省略
            case 'h5':
                currentConfig['data'] = {
                    channel: channelName,
                    type: 'text',
                    title: title,
                    content: desc,
                    icon: icon,
                    url: link
                };
                break;
            case 'miniapp':
                currentConfig['data'] = {
                    channel: channelName,
                    type: 'miniApp',
                    title: title,
                    content: desc,
                    icon: img,
                    url: path,
                    ext: {
                        path,
                        appId: appid,
                        programType: miniprogram_type,
                        miniprogramType: miniprogram_type
                    }
                };
                break;
            case 'image':
                currentConfig['data'] = {
                    channel: channelName,
                    type: 'image',
                    image: img
                };
                break;
        }
        return currentConfig.data;
    }
};
const formatFusionShareConfig = (shareConf) => {
    let buttons = [];
    let result = { buttons };
    Object.entries(shareConf.share_channels).forEach(([channel, channelConf]) => {
        let currentButtonConfig = {
            type: 'shareWeixinAppmsg',
            data: {
                type: 'text',
                title: '',
                icon: '',
                content: '',
                url: ''
            }
        };
        currentButtonConfig['type'] =
            channelMapping[channel] && channelMapping[channel].API;
        const { share_type } = channelConf;
        const currentConfig = {
            ...shareConf[share_type]
        }; // 传给底层的分享物料
        if (!currentConfig)
            return; // 没有分享物料则返回
        const { title, img, icon, desc } = currentConfig;
        const { path, appid, miniprogram_type = 0, link } = channelConf;
        const shareMaterial = channelConf.share_type.split('_');
        switch (shareMaterial[1] || shareMaterial[0]) {
            // 分享2.0下发的share_type，会以平台_类型的形式下发
            // 例如 wx_h5（微信h5卡片），wx_miniapp(微信小程序卡片)
            case 'h5':
                currentButtonConfig['data'] = {
                    type: 'text',
                    title: title,
                    content: desc,
                    icon: icon,
                    url: link
                };
                break;
            case 'miniapp':
                currentButtonConfig['data'] = {
                    type: 'miniApp',
                    title: title,
                    content: desc,
                    icon: img,
                    url: path,
                    ext: {
                        path,
                        appId: appid,
                        programType: miniprogram_type,
                        miniprogramType: miniprogram_type
                    }
                };
                break;
            case 'dcommand':
                currentButtonConfig['data'] = {
                    type: 'dcommand',
                    dcommand_content: currentConfig.dcommand_text
                };
                break;
            case 'image':
                currentButtonConfig['data'] = {
                    type: 'image',
                    image: img
                };
            default:
        }
        buttons.push(currentButtonConfig);
    });
    const refreshButton = {
        type: 'refreshPage',
        data: {}
    };
    buttons.push(refreshButton);
    result.buttons = buttons;
    return result;
};
const formatWebviewSetShareConfig = function (env, shareConf) {
    const envChannelConfig = {
        dy: 'dy_appmsg',
        ali: 'ali_appmsg',
        wx: 'wx_appmsg'
    };
    const { share_channels } = shareConf;
    // xenvConfig命名修改
    /*
      xenvConfig: {
        path,
        share_type
      }
    */
    const xenvConfig = share_channels[envChannelConfig[env]];
    if (!xenvConfig) {
        throw new Error('不存在当前环境对应的分享渠道');
    }
    const { share_type } = xenvConfig;
    const shareMaterialConfig = {
        //  分享物料
        ...shareConf[share_type]
    }; // 传给底层的分享物料
    const { title, img, icon, desc, custom = {} } = shareMaterialConfig;
    if (xenvConfig.share_type.split('_')[1] !== 'miniapp')
        return; // 微信小程序webview 只能设置分享小程序
    const { path } = xenvConfig;
    /* 区分微信/支付宝/抖音小程序 分别传入对应的config */
    const wechatWebviewConfig = {
        type: 'share',
        data: {
            title,
            imageUrl: img,
            url: path,
            mpPath: path
        }
    };
    switch (env) {
        case 'wx':
            /* 微信小程序环境下 */
            if (urlParams['xwebapp']) {
                // 滴滴出行小程序webview环境
                const wechatShortConfig = {
                    data: wechatWebviewConfig
                };
                return wechatShortConfig;
            }
            else {
                // 其他环境
                const wechatLongConfig = {
                    data: {
                        path,
                        title,
                        imageUrl: img,
                        ...wechatWebviewConfig
                    }
                };
                return wechatLongConfig;
            }
        case 'ali':
            // 支口令、支付宝海报单独是一套物料，放在custom里，优先使用
            const { ali_content, ali_bg_img_url } = custom;
            const aliWebviewConfig = {
                type: 'share',
                data: {
                    title: title,
                    desc: desc,
                    content: ali_content || title,
                    imageUrl: icon,
                    bgImgUrl: ali_bg_img_url || img,
                    scImgUrl: img,
                    url: path,
                    mpPath: path
                }
            };
            const aliShortConfig = {
                data: aliWebviewConfig
            };
            return aliShortConfig;
    }
};
const convertInvokeShareMaterial = function (_shareConf) {
    // 物料转化规则，本次支持passenger -> miniApp； wxmp -> wxmp 的分享格式化。
    // 其余环境by需求扩充
    const currentXenv = xenv();
    const xenvFormatShareConfig = {
        'hitchapp': formatFusionInvokeShareConfig,
        'alimp': formatWebviewInvokeShareConfig,
        'sfcalimp': formatWebviewInvokeShareConfig,
        'passenger': formatFusionInvokeShareConfig,
        'kfpassenger': formatFusionInvokeShareConfig,
        'wxmp': formatWebviewInvokeShareConfig,
        'sfcwxmp': formatWebviewInvokeShareConfig,
        'hwfastapp': formatWebviewInvokeShareConfig,
        'kfwxmp': formatWebviewInvokeShareConfig,
        'kfalimp': formatWebviewInvokeShareConfig
    };
    const formatFn = xenvFormatShareConfig[currentXenv];
    return formatFn(_shareConf) || null;
};
const formatWebviewInvokeShareConfig = function (_shareConf) {
    const supportTransitionSharePageList = ['wxmp', 'sfcwxmp', 'hwfastapp'];
    let commonConfig = {
        activity_id: _shareConf?.mpShareConfig?.activity_id,
        bs_id: _shareConf?.mpShareConfig?.bs_id
    };
    if (!commonConfig.activity_id || !supportTransitionSharePageList.includes(xenv())) {
        // 没有activity_id以及非supportTransitionSharePageList环境下，右上角setShare
        return convertSetShareMaterial(_shareConf);
    }
    else {
        return formatTransitionPageShareConfig(_shareConf);
    }
};
const formatTransitionPageShareConfig = (_shareConf) => {
    // 朋友圈配置 start
    let commonConfig = {
        ...(webappXenv.includes(xenv()) ? _shareConf['wx_h5'] : _shareConf['wx_miniapp']),
        activity_id: _shareConf?.mpShareConfig?.activity_id,
        bs_id: _shareConf?.mpShareConfig?.bs_id
    };
    let { mpShareConfig, share_channels } = _shareConf;
    // 海报的share_type为image，对应的share_data也是image
    const timeLineData = _shareConf['image'];
    const configList = share_channels['wx_appmsg'];
    const missMiniAppData = (!configList || (!webappXenv.includes(xenv()) && configList.share_type.split('_')[1] !== 'miniapp'));
    if (missMiniAppData && !timeLineData) {
        // 没有海报数据，且没有分享类型为miniapp的渠道数据
        throw new Error('传给分享中间页的分享数据缺失');
    }
    const extraParams = omit(mpShareConfig.extra, mpShareConfigExtraIgnoreList);
    mpShareConfig = {
        // 当前有两种来源，1业务传入。2webx返回，后续会收到一起
        ...mpShareConfig,
        ...commonConfig.mpShareConfig
    };
    let result = {
        ...extraParams,
        activity_id: mpShareConfig.activity_id,
        bs_id: mpShareConfig.bs_id || '',
        share_title: mpShareConfig.share_title,
        share_tip_title: mpShareConfig.share_tip_title,
        share_subTitle: mpShareConfig.share_subTitle || commonConfig.desc,
        share_imgUrl: mpShareConfig.share_imgUrl,
        share_shareTitle: mpShareConfig.share_shareTitle || commonConfig.title || '滴滴出行',
        share_shareImgUrl: mpShareConfig.share_shareImgUrl || commonConfig.img || 'https://ut-static.udache.com/webx/mini-pics/U7mDFxU2yh-2-r1BJ-J0X.png',
        share_share_group_btn_text: mpShareConfig.share_share_group_btn_text,
        share_share_group_btn_image: mpShareConfig.share_share_group_btn_image,
        poster_title: mpShareConfig.poster_title || '保存成功，快去分享吧！',
        poster_sub_title: mpShareConfig.poster_sub_title,
        poster_image_url: mpShareConfig.poster_image_url || timeLineData?.img || '',
        poster_btn_text: mpShareConfig.poster_btn_text,
        poster_btn_image: mpShareConfig.poster_btn_image,
        other_type: mpShareConfig.other_type
    };
    if (!configList || (!webappXenv.includes(xenv()) && configList.share_type.split('_')[1] !== 'miniapp'))
        return result;
    // 没有配渠道的话就不拼path，中间页就不会展示分享微信好友的按钮
    const targetUrl = {
        'miniapp': 'path',
        'h5': 'link'
    }[configList.share_type.split('_')[1]];
    result.share_sharePath = mpShareConfig.share_sharePath
        ? encodeURIComponent(decodeURIComponent(filtrateParams(mpShareConfig.share_sharePath)))
        : encodeURIComponent(build(filtrateParams(configList[targetUrl]), {}));
    return result;
};
// 分享中间页埋点参数过滤列表
const mpShareConfigExtraIgnoreList = [
    'type',
    'activity_id',
    'bs_id',
    'share_title',
    'share_tip_title',
    'share_subTitle',
    'share_imgUrl',
    'share_shareTitle',
    'share_sharePath',
    'share_shareImgUrl',
    'share_share_group_btn_text',
    'share_share_group_btn_image',
    'poster_title',
    'poster_sub_title',
    'poster_img_url',
    'poster_image_url',
    'poster_btn_text',
    'poster_btn_image',
    'other_type',
];
// 过滤指定属性
const omit = (originObj, ignoreList) => {
    if (!utils.isObj(originObj))
        return {};
    const obj = utils.cloneDeep(originObj);
    for (let key in obj) {
        if (ignoreList.includes(key)) {
            delete obj[key];
        }
    }
    return obj;
};
const initShare = function (_data, isSSRInitWebx = false) {
    /** 如果是SSR由于initSDK的时候已经激活所以直接从storage上取就可以 */
    let shareConf = storage.shareConf;
    /** 如果不是SSR那么从响应体上获取分享数据 */
    if (!isSSRInitWebx) {
        shareConf = getShareDataFromInit(_data);
    }
    if (shareConf?.errCode) {
        getOmega((omega) => {
            omega.trackError('share_conf_error', shareConf?.errMsg, {
                ...shareConf
            });
        });
        shareConf = {};
    }
    /** 如果不是SSR初始化，那么全部解构赋值，兼容业务异常处理多次initShare */
    if (!isSSRInitWebx) {
        storage.shareConf = shareConf;
    }
    console.log('share 初始化成功', storage.shareConf);
    let indexShareConf;
    for (let shareItem in shareConf) {
        if (shareConf[shareItem]?.isDefault)
            indexShareConf = shareConf[shareItem];
    }
    if (!indexShareConf || !indexShareConf.open_share) {
        // 没有主会场分享数据或
        // 未开启分享，直接禁用
        disableShare();
    }
    else {
        setShareV2();
    }
    // return shareConf
};
const invokeShareV2 = function (xposData, extraData = {}) {
    if (!xposData) {
        throw new Error('传入参数不能为空');
    }
    const { query = {}, xak = urlParams.xak, mpShareConfig = {} } = extraData;
    let baseXposShare = utils.cloneDeep(xposData);
    if (baseXposShare.target && isDOMShare(baseXposShare.target)) {
        // TODO 如果是一个dom，可以不深拷贝
        // 有target为一个dom
        // 进度dom读取的流程
        baseXposShare = getXposShareInfoByDom(xposData.target);
    }
    /*
      baseXposShare: {
        pd, cid
      }
    */
    let targetShareConfig = getTargetShareConf({
        shareConf: storage.shareConf,
        baseXposShare,
        xak
    });
    /*
    targetShareConfig: {
        wx_miniapp: {title, icon, img}
        share_channels: currentShareChannels,
        xposShare
      }
    */
    const formatShareConfig = getFormatShareConf({
        shareConf: targetShareConfig,
        query
    });
    const convertShareConf = convertInvokeShareMaterial({ ...formatShareConfig, mpShareConfig });
    const xenvInvokeShareMapping = {
        passenger: passengerInvokeShare,
        wxmp: wxmpInvokeShareV2,
        sfcwxmp: sfcwxmpInvokeShareV2,
        alimp: alimpInvokeShareV2,
        sfcalimp: sfcalimpInvokeShareV2,
        hwfastapp: hwfastappInvokeShareV2,
        kfpassenger: kfpassengerInvokeShare,
        kfalimp: kfalimpInvokeShareV2,
        kfwxmp: kfwxmpInvokeShareV2
    };
    const fn = xenvActionFactory('invokeShare', xenvInvokeShareMapping);
    console.log('======= invoke分享的数据结构 ======', convertShareConf);
    return fn(convertShareConf);
};
const setShareV2 = function (...args) {
    const [baseXposShare = null, option = {}] = args;
    console.log('enter setShareV2', args);
    const { query, xak = urlParams['xak'] || urlParams['x_act_key'] } = option;
    const defaultXpos = {
        // 默认分享点位的xpos_share数据
        pk: baseXposShare?.pk || urlParams['pk'],
        cid: xak,
        en: 'default',
        idx: 'share_btn'
    };
    let targetShareConfig = getTargetShareConf({
        shareConf: storage.shareConf,
        xak,
        baseXposShare: baseXposShare || defaultXpos
    });
    let formatShareConfig = getFormatShareConf({
        // 分享path拼接
        // 根据xenv抹平物料，底层可用
        shareConf: targetShareConfig,
        query
    });
    const convertShareConf = convertSetShareMaterial(formatShareConfig);
    if (!convertShareConf) {
        throw new Error('找不到对应的分享物料');
    }
    const xenvSetShareMapping = {
        alimp: alimpSetShare,
        // 'alipay': alipayShare,
        // 'bdmp': bdmpShare,
        // 'cowxmp': cowxmpShare,
        sfcwxmp: sfcwxmpSetShare,
        sfcalimp: sfcalimpSetShare,
        // driver: driverSetShare,
        // 'drwxmp': drwxmpShare,
        // 'gjwxmp': gjwxmpShare,
        // gaswxmp: gaswxmpSetShare,
        // 'h5': h5Share,
        kfalimp: kfalimpSetShare,
        // kfdriver: kfdriverSetShare,
        hitchapp: hitchappSetShare,
        // 'kfdwxmp': kfdwxmpShare,
        kfpassenger: kfpassengerSetShare,
        kfwxmp: kfwxmpSetShare,
        // 'mqq': mqqShare,
        passenger: passengerSetShare,
        // qjwxmp: qjwxmpSetShare,
        // 'qqmp': qqmpShare,
        // 'thwxmp': thwxmpShare,
        // weixin: weixinSetShare,
        wxmp: wxmpSetShare,
        // dymp: dympSetShare,
        // hywxmp: hywxmpSetShare,
        // hyalimp: hyalimpSetShare,
        // cralimp: cralimpSetShare,
        // eshwxmp: eshwxmpSetShare,
        // hwfastapp: hwfastappSetShare
    };
    console.log('convertShareConf');
    console.log(convertShareConf);
    const fn = xenvActionFactory('setShare', xenvSetShareMapping);
    return fn(convertShareConf);
};
const webxInvokeShare = invokeShareV2;
export { invokeShareV2, initShare, webxInvokeShare };
